import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { telegramFlowApi, tradersApi } from 'api';
import { DataGridColumnDefinition } from 'components';
import { QueryKey, FilterDefinitionType } from 'enums';
import { usePartialQuery, useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { TelegramFlow, FilterDefinition, TelegramUser } from 'types';

import { TelegramFlowContext } from '../TelegramFlowDialog';
import { TelegramFlowTab } from '../TelegramFlowTab';
import { TelegramFlowFilters } from '../types';

type TradersTabProps = {
  telegramUsers: TelegramUser[];
};

export const TradersTab: React.FC<TradersTabProps> = ({ telegramUsers }) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.telegram_flow',
  });
  const { role } = useUser();

  const queryResult = usePartialQuery(
    QueryKey.TelegramFlowTraders,
    telegramFlowApi.getTradersPaginated,
  );

  const queryResultTraders = useQuery(QueryKey.Traders, () =>
    tradersApi.getAllAsRole(role)(),
  );

  const entityColumn: DataGridColumnDefinition<TelegramFlow> = {
    header: t('fields.trader'),
    valueGetter: (item) => item.trader?.user?.name || item.traderId,
  };

  const filtersDefinitions: FilterDefinition<TelegramFlowFilters>[] = useMemo(
    () => [
      {
        label: t('filters.trader'),
        name: 'traderId',
        type: FilterDefinitionType.Trader,
        traders: queryResultTraders.data,
      },
      {
        label: t('filters.chat_id'),
        name: 'chatId',
        type: FilterDefinitionType.Text,
      },
    ],
    [t, queryResultTraders.data],
  );

  return (
    <TelegramFlowTab
      filtersDefinitions={filtersDefinitions}
      entityColumn={entityColumn}
      queryResult={queryResult}
      context={TelegramFlowContext.Trader}
      telegramUsers={telegramUsers}
    />
  );
};
